import React from "react";
import { Field } from "formik";
import { RenderField } from "forms/fields";
import PropTypes from "prop-types";

import DeleteButton from "components/DeleteButton";
import Modal, { ModalBody, ModalFooter, ModalHeader } from "components/Modal";
import SubmitButton from "components/SubmitButton";
import { Translate } from "utils";
import { isRequired } from "utils/validation";

import styles from "./PortfolioModal.css";

const { t } = new Translate("PortfolioModal");

export const PortfolioModal = (props) => {
  const { handleSubmit, isEdit, isLoading, isOpen, onClose, onDelete } = props;
  if (!isOpen) return null;

  return (
    <Modal onClose={onClose} width={290} isOpen>
      <form onSubmit={handleSubmit}>
        <ModalHeader onClose={onClose}>{isEdit ? t("titleEdit") : t("titleAdd")}</ModalHeader>
        <ModalBody>
          <div className={styles.body}>
            <Field
              component={RenderField}
              label={t("nameLabel")}
              name="name"
              validate={isRequired}
              autoFocus
            />
          </div>
        </ModalBody>
        <ModalFooter>
          {isEdit && <DeleteButton onClick={onDelete} />}
          <SubmitButton
            isSubmitting={isLoading}
            submitLabel={t("save")}
            submittingLabel={t("saving")}
          />
        </ModalFooter>
      </form>
    </Modal>
  );
};

PortfolioModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
};

export default PortfolioModal;
